<!--TODO:Pasos Identificacion-->
<div class="m-b-60 p-y-97 d-none">
  <img class="logo-img-size logo__white" [src]="url_img.logo_white" alt>

  <div
    class="figures-steps-styles d-flex flex-row justify-content-between align-items-center m-t-46">
    <!--Agregar la clase para activar en color activo step-circle-active -->
    <div
      class="container-all-step d-flex flex-column justify-content-center align-items-center"
      [ngClass]="{'step-circle-active': showStateCircleOne(), 'step-circle-check': showStateCheckOne()  }">
      <div
        class="step-circle-style m-b-9 d-flex justify-content-center align-items-center">
        <span class="step-into-style">
          <span class="number-check-white">1</span>
          <img class="img-check-white" [src]="url_img.check_white" alt>
        </span>
      </div>
      <span
        class="step-info-style text-center line-height-16 white-space-nowrap">
        Sube tus <br>documentos
      </span>
    </div>
    <!--Agregar la clase para activar en color activo step-line-active -->
    <div class="container-line-step"
      [ngClass]="{'step-line-active': showStateLineOne(), 'step-line-check': showStateLineOneCheck() }"></div>

    <div
      class="container-all-step d-flex flex-column justify-content-center align-items-center"
      [ngClass]="{'step-circle-active': showStateCircleTwo(), 'step-circle-check': showStateCheckTwo()  }">
      <div
        class="step-circle-style m-b-9 d-flex justify-content-center align-items-center">
        <span class="step-into-style">
          <span class="number-check-white">2</span>
          <img class="img-check-white" [src]="url_img.check_white" alt>
        </span>
      </div>
      <span
        class="step-info-style  text-center line-height-16 white-space-nowrap">
        Completa <br>tu información
      </span>
    </div>
    <!--step-circle-check-->
    <div class="container-line-step"
      [ngClass]="{'step-line-check': showStateLineTwo() }"></div>

    <div
      class="container-all-step d-flex flex-column justify-content-center align-items-center"
      [ngClass]="{'step-circle-active': showStateCircleThree(), 'step-circle-check': showStateCheckThree() }">
      <div
        class="step-circle-style m-b-9 d-flex justify-content-center align-items-center">
        <span class="step-into-style">
          <span class="number-check-white">3</span>
          <img class="img-check-white" [src]="url_img.check_white" alt>
        </span>
      </div>
      <span
        class="step-info-style  text-center line-height-16 white-space-nowrap">
        Confirma <br> tus datos
      </span>
    </div>

  </div>
</div>

<div class="content__steppers">
<div class="steppers__top">
  <div class="steppers__logo">
    <img class="logo__bursanet" [src]="url_img.logo_white">
  </div>

  <div class="steppers__circles">    
    <div class="circle__item" [ngClass]="{'step-circle-active': showStateCircleOne(), 'step-circle-check': showStateCheckOne()  }">
      <span class="item__text">1</span>
      <img class="item__check" [src]="url_img.check__white">
      <div class="item__out">
        <span class="out__text">Sube tus <br> documentos</span>
      </div>
    </div>
    <div class="line__item" [ngClass]="{'step-line-active': showStateLineOne(), 'step-line-check': showStateLineOneCheck() }">
      <hr class="line__white">
    </div>

    <div class="circle__item" [ngClass]="{'step-circle-active': showStateCircleTwo(), 'step-circle-check': showStateCheckTwo()  }">
      <span class="item__text">2</span>
      <img class="item__check" [src]="url_img.check__white">
      <div class="item__out">
        <span class="out__text">Completa <br> tu información</span>
      </div>
    </div>
    <div class="line__item" [ngClass]="{'step-line-check': showStateLineTwo() }">
      <hr class="line__white">
    </div>

    <div class="circle__item" [ngClass]="{'step-circle-active': showStateCircleThree(), 'step-circle-check': showStateCheckThree() }">
      <span class="item__text">3</span>
      <img class="item__check" [src]="url_img.check__white">
      <div class="item__out">
        <span class="out__text">Confirma <br> tus datos</span>
      </div>
    </div>

  </div>

</div>
 
</div>
